
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanSetupModel } from './Entities.Accounting.AccountingPlanSetup';
import { PriceAdjustmentValueModel } from './Entities.Accounting.PriceAdjustmentValue';
import { Model, ModelProperty } from 'models/Model';


export class PriceAdjustmentModel extends Model<PriceAdjustmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'priceAdjustment.property.id', isHidden: true },
		{ name: 'deactivated', type: 'boolean', languageString: 'priceAdjustment.property.deactivated' },
		{ name: 'annualAdjustmentPercent', type: 'number', languageString: 'priceAdjustment.property.annualAdjustmentPercent' },
		{ name: 'accountingPlanSetups', type: 'AccountingPlanSetupModel[]', languageString: 'priceAdjustment.property.accountingPlanSetups', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'priceAdjustmentValues', type: 'PriceAdjustmentValueModel[]', languageString: 'priceAdjustment.property.priceAdjustmentValues', isHidden: true, isArray: true, isObject: true, new: () => { return new PriceAdjustmentValueModel }, properties: () => { return PriceAdjustmentValueModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public deactivated: boolean;
	public annualAdjustmentPercent: number;
	public accountingPlanSetups: AccountingPlanSetupModel[];
	public priceAdjustmentValues: PriceAdjustmentValueModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.deactivated = false;
		this.annualAdjustmentPercent = 0;
		this.accountingPlanSetups = [];
		this.priceAdjustmentValues = [];
		
	}
	getProperties(){
		return PriceAdjustmentModel.classProperties;
	}
}

